import { useGetLogger } from "@hooks/useGetLogger";
import { useEffect } from "react";
import { MetricName } from "@constants/logging";
import { StepId } from "@constants/navigation";

export const useLogStep = (stepDimension: StepId) => {
    const logger = useGetLogger();

    useEffect(() => {
        stepDimension &&
            logger.publishMetricWithDimensions(MetricName.STREAMING_FLOW, {
                Step: stepDimension,
            });
    }, [stepDimension]);
};
